import loginStateService from "../services/login-state.service";
import { signInWithRedirect } from "aws-amplify/auth";

interface LocationStateData {
  pathname?: string;
  search?: string;
  hash?: string;
}

interface RedirectToOAuthLoginParams {
  identityProvider: string;
  stateData: any;
}

const stripIdentityProvider = (stateData: any): any => {
  if (!stateData?.search) {
    return stateData;
  }

  const params = new URLSearchParams(stateData.search);
  params.delete("identity_provider");

  const search = params.toString();

  return {
    ...(stateData as LocationStateData),
    search: search ? `?${search}` : ""
  };
};

const redirectToOAuthLogin = ({
  identityProvider,
  stateData
}: RedirectToOAuthLoginParams): void => {
  const state = loginStateService.saveState(stripIdentityProvider(stateData));

  signInWithRedirect({
    provider: { custom: identityProvider },
    customState: state
  });
};

export default redirectToOAuthLogin;
